import React from "react"
import { FieldValues, useForm } from "react-hook-form"
import { useNavigate } from "react-router"
import { InputField, PasswordField } from "@/components/packages/components-v2"
import Button from "@mui/material/Button"
import Grid from "@mui/material/Grid"
import axiosInstance from "../../../xhr/axiosInstance";
import {Alert} from "@mui/material";
import Link from "@mui/material/Link";

export default function LoginForm() {
  const navigate = useNavigate()
    const [errorMessage, setErrorMessage] = React.useState<string | null>(null);
  const {
    control,
    handleSubmit,
    register,
    formState: { errors, isDirty, isSubmitting },
  } = useForm()

  const getUserDetails = async () => {
    axiosInstance.get('/auth/user').then((response) => {
      localStorage.setItem('permissions', JSON.stringify(response.data.permissions));
    })
  }

  const onFinish = async (values: FieldValues) => {
    setErrorMessage(null)
    axiosInstance.post("auth/login/", {
      username: values.username,
      password: values.password,
    }).then(response => {
      if (response.data.key) {
        axiosInstance.defaults.headers.common["Authorization"] = 'Token ' + response.data.key;
        localStorage.setItem("username", values.username);
        localStorage.setItem("userId", response.data.u);
        localStorage.setItem("userToken", response.data.key);

        axiosInstance.post('/auth/login/', {
            username: values.username,
            password: values.password,
        }).then((response) => {
          localStorage.setItem('permissions', JSON.stringify(response.data.permissions));
          window.location.href = "/"
        }).catch(response => alert("!"));
      }
    }).catch((error) => {
        const responseData = error.response?.data;
        if (responseData){
            const message = Object.values(responseData).flat().join(" ");
            setErrorMessage(message);
            return;
        }
        else {
            setErrorMessage("Er is een fout opgetreden tijdens het inloggen.");
        }
    })
  }

  return (
    <form onSubmit={handleSubmit(onFinish)}>

      <Grid container direction="column" spacing="4">
        <Grid item>
          <InputField
            label="Username"
            control={control}
            error={errors.username}
            {...register("username")}
          />
        </Grid>

        <Grid item>
          <PasswordField
            label="Password"
            control={control}
            error={errors.password}
            {...register("password")}
          />
        </Grid>
        <Grid item>
              {errorMessage ? (
                  <Alert severity="error">
                        {errorMessage}
                  </Alert>
              ) : null }
          </Grid>
        <Grid item sx={{ marginTop: 4 }}>
          <Button
            variant="contained"
            color="primary"
            type="submit"
            sx={{ float: "right" }}
          >
            Inloggen
          </Button>
        </Grid>
        <Grid item sx={{ marginTop: 2, }} >
            <Link href="password-reset" variant="body2" color="#37474F" style={{float: "right"}}>
                Wachtwoord opnieuw instellen
            </Link>
        </Grid>
      </Grid>

    </form>
  )
}